<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
          <graph-tool-bar :dateRangeMenu="false" :showApplianceMenu="false"></graph-tool-bar>
        </md-card-header>

        <md-card-content>
          <div
            class="md-layout-item md-xsmall-size-100 md-small-size-60 md-medium-size-40 md-large-size-25"
          >
            <md-field :class="[{ 'md-error': errors.has('NILM_TRESHOLD') }]">
              <label>{{$lang.inputs.active_power_threshold}}</label>
              <md-input
                v-model="treshold"
                data-vv-name="NILM_TRESHOLD"
                type="text"
                name="NILM_TRESHOLD"
                v-validate="modelValidations.treshold"
              ></md-input>
              <slide-y-down-transition>
                <md-icon class="error" v-show="errors.has('NILM_TRESHOLD')">close</md-icon>
              </slide-y-down-transition>
              <span class="md-suffix">W</span>
            </md-field>
          </div>

          <div
            class="md-layout-item md-xsmall-size-100 md-small-size-60 md-medium-size-50 md-large-size-30"
          >
            <md-switch
              v-model="automaticLearn"
            >{{$lang.keys.automatic_learn}}</md-switch>
          </div>

          <br />
          <div class="md-layout-item md-size-100 md-auto">
            <md-button
              @click="saveSettings()"
              class="md-success"
            >{{$lang.keys.save}}</md-button>

            <md-button
              @click="deleteAllAppliancesImprints()"
              class="md-danger"
            >{{$lang.keys.delete_all_imprints}}</md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import graphToolBar from "@/components/GraphToolBar";
import axios from "axios";
import { getUserToken, getSelectedDeviceToken } from "@/storage/memoryStorage";
import snackBar from "@/components/SnackBar";
import Swal from "sweetalert2";
import { handleRedirect } from "@/routes/routes";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    SlideYDownTransition
  },
  data() {
    return {
      modelValidations: {
        treshold: {
          required: true,
          min_value: 5,
          max_value: 500
        }
      },
      automaticLearn: null,
      treshold: 25
    };
  },
  computed: {
    selectedDevice() {
      return this.$store.getters.getSelectedDevice;
    }
  },
  watch: {
    selectedDevice: function(newDevice, oldDevice) {
      if (!newDevice.owner) {
        this.$router.push({
          path: handleRedirect()
        });
      }
      if (newDevice.mac !== oldDevice.mac) {
        this.loadSettings();
      }
    }
  },

  created() {
    this.loadSettings();
  },

  methods: {
    loadSettings() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/settings",
        data: {
          token: getSelectedDeviceToken(this.selectedDevice.mac)
        },
        withCredentials: true
      })
        .then(response => {
          if (response.data.status === "OK") {
            this.automaticLearn = response.data.data.clustering;
            this.treshold = response.data.data.treshold;
          }
        })
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
          this.automaticLearn = false;
        });
    },

      saveSettings() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_W + "/nilm/settings",
        data: {
          user_token: getUserToken(),
          device_token: getSelectedDeviceToken(this.selectedDevice.mac),
          treshold: Number(this.treshold),
          autoLearn: this.automaticLearn
        }
      })
        .then(response => {
          this.$refs.snackbar.notify(this.$lang.messages.settings_successfully_saved);
        })
        .catch(error => {
          this.$refs.snackbar.notify(
            this.$lang.messages.api_communication_error
          );
        });
    },

    deleteAllAppliancesImprints() {
      Swal.queue([
        {
          title: this.$lang.general.are_you_sure,
          type: "warning",
          showCancelButton: true,
          cancelButtonClass: "md-button md-danger",
          cancelButtonText: this.$lang.keys.cancel,
          confirmButtonClass: "md-button md-success",
          confirmButtonText: this.$lang.keys.yes,
          buttonsStyling: false,
          showLoaderOnConfirm: true,

          preConfirm: () => {
            return axios({
              method: "DELETE",
              url: this.$ENDPOINTS.API_R + "/nilm/appliances",
              data: {
                user_token: getUserToken(),
                device_token: getSelectedDeviceToken(this.selectedDevice.mac),
                remove: "ALL"
              },
              withCredentials: true
            })
              .then(() => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.success,
                  text: this.$lang.messages.success_removed_device,
                  type: "success",
                  confirmButtonClass: "md-button md-success",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false,
                  timer: 2000
                });
              })
              .catch(error => {
                Swal.insertQueueStep({
                  title: this.$lang.messages.error,
                  text: this.$lang.messages.api_communication_error,
                  type: "error",
                  confirmButtonClass: "md-button md-warning",
                  confirmButtonText: this.$lang.keys.close,
                  buttonsStyling: false
                });
              });
          }
        }
      ]);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-layout {
  margin-top: -29px;
}
</style>